import React from "react";
import MicroFrontend from "./micro-frontend";
import {UrlExtractor} from "./util/UrlExtractor";
import PicData from "./entity/PicData";

interface PicModuleLoaderProps {
  history?: any;
  data?: PicData;
}

const PicModuleLoader = ({history, data}: PicModuleLoaderProps) => {
  const moduleName = "PicModule";
  const cloudFrontUrl = UrlExtractor.getCloudFrontUrl();

  const emptyData = {} as PicData;
  // Inject api gateway url
  data = (data || emptyData);
  data.apiEndpoint = UrlExtractor.getApiGatewayUrl();

  return (
    <MicroFrontend
      name={moduleName}
      history={history}
      data={data}
      cloudFrontUrl={cloudFrontUrl}
    />
  );
};

export default PicModuleLoader;
